import { useActionsOverTimeStatisticsWorkflow } from "@/api/useWorkflow"
import { ActionsOverTimeWidgetComponent } from "./ActionsOverTimeWidgetComponent"

export const ActionsOverTimeWidget = () => {
  const context = useActionsOverTimeStatisticsWorkflow()
  const { isLoading, response } = context
  const { data } = response || {}

  return <ActionsOverTimeWidgetComponent data={data} isLoading={isLoading} />
}
